/* globals document window */
import React, { useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { GoogleApiWrapper } from 'google-maps-react';

let autoComplete;

const loadScript = (url, callback) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

async function handlePlaceSelect(updateQuery, setAddress) {
  const addressObject = autoComplete.getPlace();
  const { address_components, formatted_address } = addressObject;
  if (!address_components) return;
  const getLongMeta = (meta) =>
    (address_components.find((component) => component.types[0] === meta) || {})
      .long_name;
  const getShortMeta = (meta) =>
    (address_components.find((component) => component.types[0] === meta) || {})
      .short_name;
  updateQuery(formatted_address);
  setAddress({
    address_line_1: `${getLongMeta('street_number')} ${getLongMeta('route')}`,
    city: getLongMeta('locality') || getLongMeta('sublocality_level_1'),
    state: getShortMeta('administrative_area_level_1'),
    postal_code: getLongMeta('postal_code'),
    country: getLongMeta('country'),
    is_primary: false,
  });
}

const handleScriptLoad = (updateQuery, setAddress, autoCompleteRef) => {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { types: ['geocode'], componentRestrictions: { country: 'us' } },
  );
  autoComplete.setFields(['address_components', 'formatted_address']);
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery, setAddress),
  );
};

const SearchLocationInput = ({
  setAddress,
  isRequired = false,
  autoFocus = false,
  variant = 'standard',
  helperText = null,
}) => {
  const [query, setQuery] = useState('');
  const autoCompleteRef = useRef(null);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (hasLoaded) return;
    setHasLoaded(true);
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`,
      () => handleScriptLoad(setQuery, setAddress, autoCompleteRef),
    );
  }, [setAddress, hasLoaded, setHasLoaded]);

  return (
    <TextField
      variant={variant}
      type="text"
      inputRef={autoCompleteRef}
      onChange={(event) => setQuery(event.target.value)}
      placeholder={`Enter the address${isRequired ? ' *' : ''}`}
      value={query}
      fullWidth
      autoFocus={autoFocus}
      helperText={helperText ?? (isRequired ? 'Required' : null)}
      required={isRequired}
    />
  );
};

export default SearchLocationInput;
